import React, { useEffect, useState } from 'react'
import {
    Col,
    Row,
} from "reactstrap"
import { withTranslation } from "react-i18next";
import { listSurvey, editSurvey, surveyError, viewProfile } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import checkType from 'helpers/jwt-token-access/checkType';
import PropTypes from 'prop-types';

const ServeyComplete = (props) => {
    document.title = `${props.t("Save Survey")}  | ${props.t("Rater")}`;
    const { error, success, loading } = useSelector(state => ({
        loading: state.Survey.loading,
        error: state.Survey.error,
        success: state.Survey.success,
    }));
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [surveyData, SetSurveyData] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [profileData, setProfileData] = useState("");

    // list
    const fetchSurveyData = () => {
        dispatch(listSurvey("rater", (res) => {
            if (res?.status === 'success') {
                SetSurveyData(res?.data)
                SetItemData({})
            }
            if (res?.status === 'failure') {
                setErrorMessage(res?.message)
            }
        }))
    }

    useEffect(() => {
        fetchSurveyData()
    }, []);


    if (surveyData.survey_status == "pending") {

        navigate('/complete-self-servey/phase-one')
    }

    const next = () => {
        navigate('/complete-self-servey/phase-one')
    }

    const logout = () => {
        navigate('/logout')
    }

    useEffect(() => {
        if (checkType() == "rater") {
            dispatch(viewProfile('survey/rater/auth/me', (res) => {
                setProfileData(res?.data)
            }));
        }

    }, [])
    return (

        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Row>
                        {
                            loading ?
                                <div className="loader d-flex justify-content-center align-items-center mt-5" >
                                    <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                    {props.t("Loading")}
                                </div>
                                :
                                <div className="self-survey-main">

                                    <h4>{props.t("SURVEY_TITLE")}</h4>
                                    <p>{props.t("SURVEY_DESCRIPTION")}</p>
                                    <h5>{props.t("Username")} : {profileData?.username} </h5>
                                    <h5>{props.t("Password")} : {profileData?.password} </h5>
                                    {props.t("SURVEY_SUBDESCRIPTION")}
                                    {/* To return servey now <span className='servey-link'>
                                        <Link to="/complete-self-servey/phase-one" >
                                            click here
                                        </Link>
                                    </span> to continue you will need the User ID and Password provied above. */}
                                    <div className="thankyou-button">
                                        <button className="self-survey-btn" type='button' onClick={() => { logout() }}>{props.t('CLICK_HERE_TO_LOGOUT')}</button>
                                        {
                                            surveyData.survey_status == "pending" || surveyData.survey_status == "in-progress"
                                            && <button className="self-survey-btn countinue" onClick={() => { next() }} >{props.t("CONTINUE")}</button>
                                        }
                                    </div>
                                </div>
                        }
                    </Row>
                </div>
            </div>
        </React.Fragment>
    )
}

ServeyComplete.propTypes = {
    t: PropTypes.any,

};

export default withTranslation()(ServeyComplete);